var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.002,
    viewBox: "0 0 22 22.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(-6269 -3145.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M6284.917,3153.908l-4.705-2.091a.523.523,0,0,0-.424,0l-4.705,2.091a.524.524,0,0,0-.311.478v5.75a.523.523,0,0,0,.311.478l4.705,2.091a.523.523,0,0,0,.424,0l4.705-2.091a.523.523,0,0,0,.311-.478v-5.75A.524.524,0,0,0,6284.917,3153.908Zm-4.917-1.041,3.418,1.519-3.418,1.519-3.418-1.519Zm-4.182,2.324,3.659,1.626v4.606l-3.659-1.626Zm4.705,6.232v-4.606l3.659-1.626v4.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M6278.8,3148.46l.676-.676v1.875a.523.523,0,0,0,1.046,0v-1.875l.676.676a.523.523,0,1,0,.739-.739l-1.568-1.569a.524.524,0,0,0-.74,0l-1.568,1.569a.523.523,0,0,0,.739.739Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M6281.2,3165.54l-.676.676v-1.875a.523.523,0,0,0-1.046,0v1.875l-.676-.676a.523.523,0,0,0-.739.739l1.568,1.569a.524.524,0,0,0,.74,0l1.568-1.569a.523.523,0,0,0-.739-.739Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M6273.471,3152.626l-1.623-.937.922-.247a.523.523,0,1,0-.27-1.01l-2.142.574a.524.524,0,0,0-.37.64l.574,2.142a.523.523,0,1,0,1.01-.27l-.247-.923,1.623.937a.523.523,0,0,0,.523-.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M6289.438,3160.212a.522.522,0,1,0-1.009.27l.247.923-1.624-.937a.523.523,0,0,0-.523.906l1.623.937-.922.247a.523.523,0,1,0,.27,1.01l2.142-.574a.523.523,0,0,0,.37-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M6286.791,3153.6a.518.518,0,0,0,.261-.07l1.624-.937-.247.923a.522.522,0,1,0,1.009.27l.574-2.142a.523.523,0,0,0-.37-.64l-2.142-.574a.523.523,0,0,0-.27,1.01l.923.247-1.624.937a.523.523,0,0,0,.262.976Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M6272.948,3160.468l-1.623.937.247-.923a.523.523,0,1,0-1.01-.27l-.574,2.142a.523.523,0,0,0,.37.64l2.142.574a.523.523,0,1,0,.27-1.01l-.923-.247,1.624-.937a.523.523,0,0,0-.523-.906Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 22,
    height: 22,
    transform: "translate(6269 3146)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServing);
export default __webpack_public_path__ + "static/media/icon-serving.7c0e7a3f57083b3f2262ed193ca0d004.svg";
export { ForwardRef as ReactComponent };